import $ from 'jquery';
import ScrollReveal from 'scrollreveal';

export default class ScrollRevealer {
    constructor() {
        window.sr = new ScrollReveal({
            distance: 0,
            duration: 1500,
            mobile: true,
            scale: 1,
            useDelay: 'onload',
            viewFactor: 0.1,
            reset: false
        });

        const $animated = $('.js-fade-up');

        if ($animated.length) {
            sr.reveal('.js-fade-up', {
                distance: '60px',
                duration: 1000,
                easing: 'cubic-bezier(0.165, 0.84, 0.44, 1)',
                interval: 300,
                origin: 'bottom'
            });
        };
    };
};
